import React from "react";
import { Pressable } from 'react-native'
import _ from 'lodash'
import { createStyles } from 'styles/themed'
import HelperPlatform from 'utils/helper-platform'
import isEqual from 'react-fast-compare'


const ThemedPressable = ( props ) => {
	let testID = _.get( props, 'testID', null );
	let hitSlop = _.get( props, 'hitSlop', 0 );
	if( !_.isInteger( hitSlop ) ) {
		hitSlop = 0;
	}
	
	// Check if the there is a press property set
	let useOpacity = false;
	_.forEach( props, (f, prop) => {
		if( _.startsWith( prop, 'on' ) && _.isFunction( props[ prop ] ) ) {
			useOpacity = true;
			return false;
		}
	})
	
	// Remove the original hitslop
	props = _.omit( props, 'hitSlop' )
	props = _.omit( props, 'testID' )
	
	const pressableStyle = HelperPlatform.select({
		native: {
			flex: 1
		},
		web: {
			flex: 'none',
			cursor: 'pointer'
		}
	});
	
	const dynamicUnpressedStyle = [
		pressableStyle,
		createStyles({ opacity: 1 }, props ) ];
	
	const dynamicPressedStyle = [
		pressableStyle,
		createStyles( { opacity: ( useOpacity ? 0.72 : 1.0 ) } ,props )
	];
	
	return (
		<Pressable
			{ ...props }
			style={ ( { pressed } ) => {
				return pressed ? dynamicPressedStyle : dynamicUnpressedStyle;
			} }
			hitSlop={ hitSlop }
			testID={ testID }>
			
			{ props.children }
		</Pressable>
	)
}

export default React.memo( ThemedPressable, isEqual );
